import { Bookmark, ExternalLink } from "lucide-react";
import Comments from "@/components/Comments";

const NewsCard = ({ article, idx, formatDate, onArticleClick, onToggleBookmark, isBookmarked, getFallbackImage, onAuthClick }) => {
  return (
    <div className="transition-all duration-300 rounded-xl overflow-hidden shadow-xl"
      style={{ backgroundColor: "var(--color-card)", border: "1px solid var(--color-border)" }}
      data-testid={`news-card-${idx}`}>
      <div onClick={(e) => onArticleClick(article, e)} className="group w-full text-left transition-colors cursor-pointer">
        {article.image_url && (
          <div className="aspect-video overflow-hidden relative">
            {article.category && (
              <span className="absolute top-2 sm:top-3 left-2 sm:left-3 px-2 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-xs font-bold tracking-wider uppercase text-white rounded-full z-10 shadow-lg flex items-center gap-1.5"
                style={{ backgroundColor: "var(--color-accent)" }}>
                <span className="relative flex h-1.5 w-1.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white"></span>
                </span>
                LIVE
              </span>
            )}
            <img src={article.image_url} alt={article.title}
              className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110 group-hover:brightness-110"
              loading="lazy" onError={(e) => { e.target.src = getFallbackImage(article.category); }} />
          </div>
        )}
        <div className="p-4 sm:p-6">
          {article.category && (
            <span className="inline-block px-2 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-xs font-bold tracking-wider uppercase rounded-full mb-2 sm:mb-3"
              style={{ backgroundColor: "var(--color-card-hover)", color: "var(--color-accent)", border: "1px solid var(--color-border)" }}>
              {article.category}
            </span>
          )}
          <h3 className="text-base sm:text-xl lg:text-2xl font-bold tracking-tight leading-snug mt-1 sm:mt-2 mb-2 sm:mb-3 transition-colors line-clamp-3"
            style={{ color: "var(--color-text)", fontFamily: "Cabinet Grotesk, sans-serif" }}>
            {article.title}
          </h3>
          {article.description && (
            <p className="text-xs sm:text-sm leading-relaxed mb-3" style={{ color: "var(--color-text-muted)" }}>
              {article.description}
            </p>
          )}
          <button onClick={(e) => onArticleClick(article, e)}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold tracking-wide uppercase transition-all hover:brightness-110 mb-3 cursor-pointer"
            style={{ backgroundColor: "var(--color-accent)", color: "#fff" }} data-testid={`read-more-btn-${idx}`}>
            Read More <ExternalLink className="w-3.5 h-3.5" />
          </button>
          <div className="flex items-center gap-2 text-[11px] sm:text-xs mt-1 sm:mt-2" style={{ color: "var(--color-text-dim)" }}>
            <span className="font-semibold" style={{ color: "var(--color-live)" }}>{article.source}</span>
            <span>•</span>
            <span className="font-medium" style={{ color: "var(--color-text-muted)" }}>{formatDate(article.published_at).fullDate}</span>
            <span className="hidden sm:inline" style={{ color: "var(--color-text-dim)" }}>{formatDate(article.published_at).timestamp}</span>
            <span role="button" tabIndex={0} onClick={(e) => onToggleBookmark(article, e)}
              className="ml-auto p-1 rounded-lg transition-colors cursor-pointer" data-testid={`bookmark-btn-${idx}`}
              style={{ color: isBookmarked ? "var(--color-accent)" : "var(--color-text-dim)" }}>
              <Bookmark className="w-4 h-4" fill={isBookmarked ? "currentColor" : "none"} />
            </span>
          </div>
        </div>
      </div>
      <div style={{ borderTop: "1px solid var(--color-border)" }}>
        <Comments articleUrl={article.url} onAuthClick={onAuthClick} />
      </div>
    </div>
  );
};

export default NewsCard;
